import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { updateMaintenanceServicePaymentMethods } from '../../api/maintenance-service.ts';
import { UpdateMaintenanceServicePaymentMethodsRequest } from '../../api/requests/maintenance-service-request.ts';

export default function useUpdateMaintenanceServicePaymentMethods(): UseMutationResult<
  Awaited<ReturnType<typeof updateMaintenanceServicePaymentMethods>>,
  Error,
  UpdateMaintenanceServicePaymentMethodsRequest
> {
  return useMutation({
    mutationFn: updateMaintenanceServicePaymentMethods,
  });
}
